import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0.15, as: Tag = "h1" }) => {
  const MotionTag = motion(Tag);
  return (
    <MotionTag className={className} data-testid="masked-heading">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
            {i < lines.length - 1 ? " " : null}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
};

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const ChapterNumber = ({ n, dark = false }) => (
  <span
    className={`font-mono text-xs tracking-[0.35em] ${dark ? "text-gold" : "text-terra"}`}
    data-testid={`chapter-number-${n}`}
  >
    {n}
  </span>
);
